import { env } from "@/lib/environment";

export interface Testimonial {
  id: string;
  name: string;
  title: string;
  company: string;
  industry: string;
  quote: string;
  image: string;
  imageSmall: string;
  rating?: number;
}

type TestimonialInput = Omit<Testimonial, "id">;

function slugify(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/['’`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

const TESTIMONIALS_RAW: TestimonialInput[] = [
  {
    name: "Shelli C",
    title: "Founder",
    industry: "Restaurant & QSR",
    company: "Founder, Carter Sugar Shop",
    quote:
      "The Pickcel application is so user-friendly. Our menu changes quarterly, and the software allows me to schedule the menu ahead of time. So, when the holiday seasons are overwhelming, its one less thing I need to worry about.",
    image: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/shelli-c.YLqB2PONfFcE.webp",
    imageSmall: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/shelli-c.ACkFuTi_-YrS.webp",
  },
  {
    name: "Tarun C",
    title: "Assistant Manager",
    industry: "Banking and Finance",
    company: "Reserve Bank of India.",
    quote:"The overall experience with Pickcel has been great. The software makes it so simple to control and administer content remotely.",
    image: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/tarun-c._qJ11p2A3mq8.webp",
    imageSmall: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/tarun-c.G5BZiMjvjL0r.webp",
  },
  {
    name: "Michael T",
    title: "Co-Founder",
    industry: "Manufacturing",
    company: "Electrical/Electronic Manufacturing",
    quote:
      "We needed to have video running on android displays in different countries. So, we used the Pickcel's digital signage software. I liked the report function that lets me see for how long  the videos are running. And the support I received was world-class.",
    image: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/michael-t.exRrMrRmEldt.webp",
    imageSmall: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/michael-t.CfD4eZQFE9x6.webp",
  },
  {
    name: "Umesh S",
    title: "Partner",
    industry: "Restaurant and QSR",
    company: "Arogya Ahaara.",
    quote:
      "The overall experience with Pickcel is that the setup and configuration of the solution is super easy, and doesn't require any assistance. ",
    image: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/umesh-s.Op2UR8AZbaKG.webp",
    imageSmall: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/umesh-s.AXgpQoo9Tj-8.webp",
  },
  {
    name: "Varun B",
    title: "Manager",
    industry: "Retail",
    company: "Sight and Sound India.",
    quote:
      "Pickcel has the best support team. easiest digital signage software ever, no bugs.",
    image: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/varun-b.Vmy8G_o-_vRU.webp",
    imageSmall: env.NEXT_PUBLIC_CDN_URL + "/images/shared/testimonials/varun-b.a8iXN2nn1OSa.webp",
  },
];

export const TESTIMONIALS: Testimonial[] = (() => {
  const used = new Set<string>();
  return TESTIMONIALS_RAW.map(item => {
    let base = slugify(item.name);
    if (!base) base = "testimonial";
    let id = base;
    let i = 2;
    while (used.has(id)) {
      id = `${base}-${i++}`;
    }
    used.add(id);
    return { id, ...item } as Testimonial;
  });
})();

export function getFeaturedTestimonials(): Testimonial[] {
  return TESTIMONIALS;
}

export function getTestimonialsByIndustry(industry: string): Testimonial[] {
  return TESTIMONIALS.filter(testimonial =>
    testimonial.industry.toLowerCase().includes(industry.toLowerCase())
  );
}

export function getTestimonialById(id: string): Testimonial | undefined {
  return TESTIMONIALS.find(testimonial => testimonial.id === id);
}
